import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconLevels = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--levels")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M18,16 C18.7402524,16 19.3865739,16.4021661 19.7323937,16.9999275 L21,17 C21.5522847,17 22,17.4477153 22,18 C22,18.5522847 21.5522847,19 21,19 L21,19 L19.7318119,19.0010775 C19.3858493,19.5982846 18.7398375,20 18,20 C17.2601625,20 16.6141507,19.5982846 16.2681881,19.0010775 L3,19 C2.44771525,19 2,18.5522847 2,18 C2,17.4477153 2.44771525,17 3,17 L3,17 L16.2676063,16.9999275 C16.6134261,16.4021661 17.2597476,16 18,16 Z M6,10 C6.74025244,10 7.38657394,10.4021661 7.73239368,10.9999275 L21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L21,13 L7.73181186,13.0010775 C7.38584934,13.5982846 6.7398375,14 6,14 C5.2601625,14 4.61415066,13.5982846 4.26818814,13.0010775 L3,13 C2.44771525,13 2,12.5522847 2,12 C2,11.4477153 2.44771525,11 3,11 L3,11 L4.26760632,10.9999275 C4.61342606,10.4021661 5.25974756,10 6,10 Z M13,4 C13.7402524,4 14.3865739,4.40216612 14.7323937,4.99992752 L21,5 C21.5522847,5 22,5.44771525 22,6 C22,6.55228475 21.5522847,7 21,7 L21,7 L14.7318119,7.0010775 C14.3858493,7.59828461 13.7398375,8 13,8 C12.2601625,8 11.6141507,7.59828461 11.2681881,7.0010775 L3,7 C2.44771525,7 2,6.55228475 2,6 C2,5.44771525 2.44771525,5 3,5 L3,5 L11.2676063,4.99992752 C11.6134261,4.40216612 12.2597476,4 13,4 Z" id="icon--centivo--levels"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-78.000000, -749.000000)"/>
          <g id="Icon/levels">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--levels"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--levels"/>
          </g>
      </g>
  </IconWrapper>
)
